// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'information';

export const Component = () => (
  <path d='M1 12.5c0 3.19 1.123 5.885 3.37 8.13C6.614 22.878 9.31 24 12.5 24c3.19 0 5.885-1.123 8.13-3.37C22.878 18.386 24 15.69 24 12.5c0-3.19-1.123-5.885-3.37-8.13C18.386 2.122 15.69 1 12.5 1 9.31 1 6.615 2.123 4.37 4.37S1 9.31 1 12.5zm2.777 5.763C2.577 16.53 2 14.575 2 12.443c.045-2.889 1.067-5.377 3.111-7.421C7.155 3.022 9.6 2 12.487 2c2.133 0 4.088.578 5.866 1.777 1.733 1.2 3.021 2.755 3.821 4.71.844 1.955 1.022 3.955.622 6.043-.444 2.09-1.422 3.91-2.889 5.377-1.51 1.511-3.288 2.489-5.377 2.889-2.088.4-4.131.222-6.087-.622-1.955-.845-3.51-2.133-4.666-3.91zM12.5 6c.655 0 1.25.536 1.25 1.25S13.214 8.5 12.5 8.5c-.655 0-1.25-.536-1.25-1.25S11.786 6 12.5 6zm0 4.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1z' />
);

export const viewBox = '0 0 25 25';
